import { render, staticRenderFns } from "./CategoriesInfo.vue?vue&type=template&id=213fa456&scoped=true"
import script from "./CategoriesInfo.vue?vue&type=script&lang=js"
export * from "./CategoriesInfo.vue?vue&type=script&lang=js"
import style0 from "./CategoriesInfo.vue?vue&type=style&index=0&id=213fa456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213fa456",
  null
  
)

export default component.exports